module.exports = __webpack_public_path__ + "img/daftar_dex_asesmen.fba8b304.svg";